import React, { useState, useEffect } from "react";
import { Switch, Checkbox, Row, Col, Collapse, Radio, Form } from "antd";
import { softLiveOptions } from "../../../Project/AppConfiguration/Compliance";
// style
import styles from "./form.module.css";

const { Panel } = Collapse;

const ComplianceForm = ({ disabledState, getFieldValue, setFieldsValue }) => {
  const [solutionAccess, setSolutionAccess] = useState(
    getFieldValue("compliance_solution_access"),
  );
  const [reportDrillDown, setReportDrillDown] = useState(
    getFieldValue("compliance_report_drilldown"),
  );
  const [viewSignerCount, setViewSignerCount] = useState(
    getFieldValue("compliance_view_signature_certificate"),
  );
  const [signatureReportDrillDown, setSignatureReportDrillDown] = useState(
    getFieldValue("compliance_signature_report_drilldown"),
  );
  const [softLiveHotelStatus, setSoftLiveHotelStatus] = useState(
    getFieldValue("compliance_soft_live_hotel_status"),
  );
  useEffect(() => {
    setSolutionAccess(getFieldValue("compliance_solution_access"));
  }, [getFieldValue("compliance_solution_access")]);

  useEffect(() => {
    setReportDrillDown(getFieldValue("compliance_report_drilldown"));
  }, [getFieldValue("compliance_report_drilldown")]);

  useEffect(() => {
    setSignatureReportDrillDown(
      getFieldValue("compliance_signature_report_drilldown"),
    );
  }, [getFieldValue("compliance_signature_report_drilldown")]);

  useEffect(() => {
    setSoftLiveHotelStatus(getFieldValue("compliance_soft_live_hotel_status"));
  }, [getFieldValue("compliance_soft_live_hotel_status")]);

  const complianceViewSignatureCertificateOnChange = (e) => {
    if (e.target.checked) {
      setViewSignerCount(true);
      setFieldsValue({ compliance_view_signer_count: true });
    } else {
      setViewSignerCount(false);
      setFieldsValue({ compliance_view_signer_count: false });
    }
  };
  const solutionAccessOnChange = (value) => {
    setSolutionAccess((prevState) => !prevState);
    setFieldsValue({ compliance_solution_access: value });
  };
  const reportDrillDownHandler = (e) => {
    setReportDrillDown(e.target.value);
    setFieldsValue({ compliance_report_drilldown: e.target.value });
  };
  const signatureDrillDownHandler = (e) => {
    setSignatureReportDrillDown(e.target.value);
    setFieldsValue({ compliance_signature_report_drilldown: e.target.value });
  };

  return (
    <Collapse defaultActiveKey={["compliance_1"]} expandIconPosition="end">
      <Panel header="Compliance" key="compliance_1">
        <div className="is_form_2_a">
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Solution Access</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="compliance_solution_access"
                  valuePropName="checked"
                >
                  <Switch
                    disabled={disabledState}
                    onChange={solutionAccessOnChange}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Access</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      noStyle
                      name="compliance_upload"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      >
                        Upload
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xxl={2} xl={3} lg={5} sm={6}>
                    <Form.Item
                      noStyle
                      name="compliance_signature"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      >
                        Signature
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Holistic View</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_holistic_view"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Report Drilldown</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={24} xl={24} lg={24} sm={24}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_report_drilldown"
                      valuePropName="checked"
                    >
                      <Radio.Group
                        // defaultValue={getFieldValue("compliance_solution_access")}
                        value={getFieldValue("compliance_report_drilldown")}
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                        onChange={reportDrillDownHandler}
                      >
                        <Radio value="Only Missing">Only Missing</Radio>
                        <Radio value="All">All</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Signature Report Drilldown</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={24} xl={24} lg={24} sm={24}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_signature_report_drilldown"
                      valuePropName="checked"
                    >
                      <Radio.Group
                        value={getFieldValue(
                          "compliance_signature_report_drilldown",
                        )}
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                        onChange={signatureDrillDownHandler}
                      >
                        <Radio value="Only Missing">Only Missing</Radio>
                        <Radio value="All">All</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>View Signature Certificate</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_view_signature_certificate"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                        onChange={complianceViewSignatureCertificateOnChange}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>View Reports</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_view_reports"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Excel Export</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_excel_export"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Excel Share</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_excel_report_share"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>View Signer Count</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_view_signer_count"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access") ||
                          viewSignerCount
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Secondary View</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_secondary_view"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Soft Live Hotel Status</label>
              </Col>
              <Col xxl={12} xl={19} lg={15} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={21} xl={24} lg={24} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_soft_live_hotel_status"
                      // valuePropName="checked"
                    >
                      <Radio.Group
                        value={softLiveHotelStatus}
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      >
                        {softLiveOptions.map((radioItem) => (
                          <Row>
                            <Radio value={radioItem.value}>
                              {`${radioItem.label}`}
                            </Radio>
                          </Row>
                        ))}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                <label>Filter By Report Category</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{ borderBottom: "none" }}
                      name="compliance_filter_by_report_category"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Filter by Report Name</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="compliance_filter_by_report_name"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                <label>Signature Timestamp</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{ borderBottom: "none" }}
                      name="compliance_signature_timestamp"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("compliance_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
};

export default ComplianceForm;
